import Leadmanagement from "../../../jsx/components/Dashboard/LeadManagement/leadmanagement";

const LeadManagementWrapper = () => {
  return <Leadmanagement />;
};

export const allowedRoles = [
  _enum.ROUTE_PERSONAS.admin,
  _enum.ROUTE_PERSONAS.telecaller,
  _enum.ROUTE_PERSONAS.ops,
];

export default constore(LeadManagementWrapper);
